export const detectAgent = () => {
  const browserInfo = {
    iOS:
      parseFloat(
        (
          "" +
          (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(
            window.navigator.userAgent
          ) || [0, ""])[1]
        )
          .replace("undefined", "3_2")
          .replace("_", ".")
      ) || false,
    safari:
      parseFloat(
        (/.*AppleWebKit.*Version\/([0-9.]{1,8})\sSafari/i.exec(
          window.navigator.userAgent
        ) || [0, ""])[1].replace("_", ".")
      ) || false,
    isIE: "undefined" !== typeof window.document.documentMode,
    isEdge: -1 < window.navigator.userAgent.search(/(Edge)/)
  };

  return browserInfo;
};

export const addAgentClasses = () => {
  const browserInfo = detectAgent();

  // Is iOS
  if (browserInfo.iOS) {
    $("html").addClass("ios ios-" + ("" + browserInfo.iOS).replace(".", "_"));
  }

  // Is Safari
  if (browserInfo.safari) {
    $("html").addClass(
      "is-safari safari-" + ("" + browserInfo.safari).replace(".", "_")
    );
  }

  // Is IE
  if (browserInfo.isIE) {
    $("html").addClass("is-ie");
  }

  // Is Edge
  if (browserInfo.isEdge) {
    $("html").addClass("is-edge");
  }
};

export const supportsCssVars =
  window.CSS && window.CSS.supports && window.CSS.supports("--fake-var: 0");

export const getSupports = () => {
  let supports = window.browserSupports || {};

  if ("object" !== typeof supports) {
    supports = {};
  }

  supports.cssVars = supportsCssVars;

  if (!supports.cssVars) {
    document.documentElement.classList.add("no-css-vars");
  }

  supports.objectFit = false !== "objectFit" in document.documentElement.style;

  if (!supports.objectFit) {
    document.documentElement.classList.add("no-object-fit");
  }

  supports.touch = false !== "ontouchstart" in document.documentElement;
  document.documentElement.classList.toggle("is-touch", supports.touch);

  window.browserSupports = supports;

  // window.addEventListener("touchstart", function onFirstTouch(e) {
  //   e.target.removeEventListener(e.type, onFirstTouch);
  //   window.browserSupports.touch = true;
  //   document.documentElement.classList.add("is-touch");
  // });
};

export const hasSupport = feature => {
  if ("undefined" === typeof window.browserSupports) {
    getSupports();
  }

  return feature in window.browserSupports && window.browserSupports[feature];
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/browser.js